import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { subAPI } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      return;
    }

    const poll = async () => {
      if (attempts >= 5) {
        setStatus('timeout');
        return;
      }
      try {
        const res = await subAPI.status(sessionId);
        if (res.data.payment_status === 'paid') {
          setStatus('success');
          await refreshUser();
          return;
        }
        if (res.data.status === 'expired') {
          setStatus('expired');
          return;
        }
        setAttempts(prev => prev + 1);
        setTimeout(poll, 2000);
      } catch {
        setStatus('error');
      }
    };

    poll();
  }, [sessionId]);

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]" data-testid="subscription-success">
      <div className="glass-panel p-8 text-center max-w-md">
        {status === 'checking' && (
          <>
            <Loader2 className="mx-auto text-[#2F8A92] animate-spin mb-4" size={36} />
            <h2 className="font-historical text-[#D4A84A] text-2xl mb-2">Processing Payment</h2>
            <p className="font-mono text-sm text-white/80">Verifying your subscription...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="mx-auto text-[#2F8A92] mb-4" size={36} />
            <h2 className="font-historical text-[#D4A84A] text-2xl mb-2">Welcome to TSOGN</h2>
            <p className="font-mono text-sm text-white/80">Your subscription is active. Full access unlocked.</p>
          </>
        )}
        {(status === 'error' || status === 'expired' || status === 'timeout') && (
          <>
            <XCircle className="mx-auto text-red-400 mb-4" size={36} />
            <h2 className="font-historical text-[#D4A84A] text-2xl mb-2">Something went wrong</h2>
            <p className="font-mono text-sm text-white/80">
              {status === 'expired' ? 'Payment session expired.' : 'Could not verify payment. Please check your email.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
